/* eslint-disable i18next/no-literal-string -- TODO: Need design */
import type { ForbiddenError } from '@platform/core/errors';

import { ErrorMessage } from '@packages/fenrir/feedback/errors/error-message';
import { ErrorUnauthorized } from '@packages/fenrir/feedback/errors/error-unauthorized';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

import { signout } from '../../auth/signout';

type ForbiddenErrorPageProps = {
  error: ForbiddenError;
};

const reasonMapping: Record<ForbiddenError['data']['reason'], string> = {
  ORGANIZATION_ACCESS_DENIED:
    "You don't have permission to access this organization.",
  NO_ORGANIZATIONS_FOUND:
    "You don't have permission to access any organizations.",
  ACCESS_DENIED: "You don't have permission to access the portal.",
};

// TODO: S2CX-15999: Move hard coded text to translations when @platform/core/locale/i18n is enabled
export const ForbiddenErrorPage = ({ error }: ForbiddenErrorPageProps) => {
  const userEmail = error.data.user?.email;

  const errorMessage = (
    <ErrorMessage>
      {userEmail && (
        <>
          User: {userEmail}
          <br />
        </>
      )}
      <>Reason: {reasonMapping[error.data.reason]}</>
    </ErrorMessage>
  );

  const signOutAction = error.data.showAction
    ? {
        label: 'Sign out',
        onClick: () => signout(),
      }
    : undefined;

  return (
    <PagePlain>
      <PageContainerRoot>
        <ErrorUnauthorized
          errorMessages={errorMessage}
          actionButton={signOutAction}
        />
      </PageContainerRoot>
    </PagePlain>
  );
};
